'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetSetupForTests = exports.setupStyledComponents = undefined;

var _domReady = require('./domReady');

var _BrowserTest = require('../utils/BrowserTest');

var SC_ATTR = 'data-hubspot-styled-components'; // Custom for our styled-components repackage

var moveNonStyledComponentsTagsDown = function moveNonStyledComponentsTagsDown() {
  [document.head, document.body].forEach(function (container) {
    var styleTags = container.querySelectorAll('link[rel="stylesheet"], style:not([' + SC_ATTR + '])');
    [].slice.call(styleTags).forEach(function (styleTag) {
      var originalSheet = styleTag.sheet;
      try {
        // eslint-disable-next-line no-unused-expressions
        originalSheet && originalSheet.rules;
      } catch (e) {
        // Access denied when accessing rules (#6663), ignore this sheet
        return;
      }
      container.appendChild(styleTag);
      var newSheet = styleTag.sheet;
      if (!originalSheet || !originalSheet.rules || !newSheet || !newSheet.rules) return; // #5863

      // Ensure that any styles that were inserted dynamically are carried over.
      if (newSheet.rules.length < originalSheet.rules.length) {
        for (var i = 0; i < originalSheet.rules.length; i++) {
          if (originalSheet.rules[i] !== newSheet.rules[i]) {
            newSheet.insertRule(originalSheet.rules[i].cssText, i);
          }
        }
      }
    });
  });
};

var oneTimeSetupStyledComponents = function oneTimeSetupStyledComponents() {
  if (window.hasSetupStyledComponents) return;
  var head = document.head;

  var anchorTag = head.querySelector('[data-hubspot-styled-components-anchor]');
  if (anchorTag != null) {
    head.removeChild(anchorTag);
    if ((0, _BrowserTest.ignoresStyleTagInsertionOrder)()) {
      // To fix a style precedence bug in IE11 and Edge < 17, we need to "re-insert" any
      // <link rel="stylesheet"> tags on the page (#5661).
      moveNonStyledComponentsTagsDown();
    }
    window.hasSetupStyledComponents = true;
    return;
  }

  moveNonStyledComponentsTagsDown();
  window.hasSetupStyledComponents = true;
};

var setupStyledComponents = exports.setupStyledComponents = function setupStyledComponents() {
  (0, _domReady.domReady)(function () {
    setTimeout(oneTimeSetupStyledComponents, 0); // Ensure that this method runs in its own tick
  });
};

var resetSetupForTests = exports.resetSetupForTests = function resetSetupForTests() {
  window.hasSetupStyledComponents = false;
};